import React from 'react';
import { Minus, Plus, Users } from 'lucide-react';

// Driver count stepper for party bookings. Enforces a strict minimum of 4
// and maximum of 8 participants per the party package rules.
export default function DriverCountSelector({ value, onChange, min = 4, max = 8 }) {
  const count = Number(value) || 0;

  const decrement = () => {
    if (count > min) onChange(count - 1);
  };
  const increment = () => {
    if (count < max) onChange(count + 1);
  };

  const isValid = count >= min && count <= max;

  return (
    <div>
      <label className="block text-white/30 text-[10px] font-bold tracking-widest mb-2 flex items-center gap-1.5">
        <Users className="w-3 h-3" /> NUMBER OF DRIVERS ({min}–{max})
      </label>
      <div className="flex items-center gap-3">
        <button
          type="button"
          onClick={decrement}
          disabled={count <= min}
          className="w-11 h-11 flex items-center justify-center border border-white/10 bg-[#111115] text-white/70 hover:border-primary/40 hover:text-primary transition-colors disabled:opacity-30 disabled:cursor-not-allowed"
        >
          <Minus className="w-4 h-4" />
        </button>
        <div className={`w-16 h-11 flex items-center justify-center border bg-[#111115] font-black text-xl ${isValid ? 'border-primary/30 text-primary' : 'border-white/10 text-white/30'}`}>
          {count || '–'}
        </div>
        <button
          type="button"
          onClick={increment}
          disabled={count >= max}
          className="w-11 h-11 flex items-center justify-center border border-white/10 bg-[#111115] text-white/70 hover:border-primary/40 hover:text-primary transition-colors disabled:opacity-30 disabled:cursor-not-allowed"
        >
          <Plus className="w-4 h-4" />
        </button>
        <span className="text-white/30 text-xs ml-1">
          {count < min && count > 0 ? `Minimum ${min} drivers` : ''}
        </span>
      </div>
    </div>
  );
}